module.exports = __webpack_public_path__ + "img/banner_contact.5d67012e.png";